import React from "react";
import { Form } from "react-bootstrap";

const SearchBar = ({ searchQuery, onSearchChange }) => {
  return (
    <div className="d-flex align-items-center justify-content-center ">
      <Form.Group controlId="search">
        <Form.Control
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </Form.Group>
    </div>
  );
};

export default SearchBar;
